<!--
 * @Author: your name
 * @Date: 2021-04-22 11:29:07
 * @LastEditTime: 2021-05-10 15:46:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/index.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="4">待盖章</el-menu-item>
          <el-menu-item index="5">已盖章</el-menu-item>
          <el-menu-item index="6">已作废</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <list v-if="listShow" :stampedType="activeIndex"></list>
      </div>
    </div>
  </div>
</template>

<script>
import list from "./stamped/list";
export default {
  data() {
    return {
      activeIndex: "4",
      listShow:true,
    };
  },
  components: {
    list
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.listShow = false;
      setTimeout(()=>{
        this.listShow = true;
      },50)
    },
  },
}
</script>